/**
 Created by qing on 2020/5/25
 Des: 快捷方式图表
 */
import BaseChart from "../BaseChart"
import {
  CHART_CATEGORY__SHORTCUT,
  CHART_TYPE__SHORTCUT_CHART,
  SHORTCUT_BUTTON_TYPE__APPLY_FORM,
  SHORTCUT_LAYOUT_MODE__ADAPT,
  SHORTCUT_LAYOUT_MODE__FIXED
} from "../types"
import {uuid} from "../utils"

class Shortcut extends BaseChart {
  constructor() {
    super()

    this.w = 15
    this.h = 8

    this.minH = 5

    this.showPropertiesHolder = {
      showTitle: 0
    }

    this.chartPropertiesHolder = {
      layoutMode: SHORTCUT_LAYOUT_MODE__ADAPT,  //adapt:自适用,fixed:固定宽度
      lineCap: 2,  //单行按钮个数
      buttonSet: [
        {
          name: "点击编辑按钮",  //按钮名称
          optionType: SHORTCUT_BUTTON_TYPE__APPLY_FORM,  //applyForm:发起表单, openView:打开视图, openUrl:打开链接,
          id: uuid('BTN'),
          //根据类型解析
          optionContent: {
            //发起表单
            appId: '',
            formId: "",

            //打开视图
            //   "appId":"",
            //   "formId":"",
            viewId: "",
            jumpType: 1, // 1跳转视图，2跳转仪表盘

            //打开链接
            url: "",

            // 绑定微信
            bindType: 0, // 0公众号 1小程序
            // 邀请成员
            inviteType: 0, // 0成员 1外部联系人

          },
          newPage: 1,  //是否在新页面打开，否则弹窗展示
          color: this.colorOpts[0], //颜色
          customColor: "", // 自定义颜色
          icon: "" //图标
        },
        {
          name: "点击编辑按钮",  //按钮名称
          optionType: SHORTCUT_BUTTON_TYPE__APPLY_FORM,  //applyForm:发起表单, openView:打开视图, openUrl:打开链接,
          id: uuid('BTN'),

          //根据类型解析
          optionContent: {
            //发起表单
            appId: '',
            formId: "",

            //打开视图
            //   "appId":"",
            //   "formId":"",
            viewId: "",
            jumpType: 1, // 1跳转视图，2跳转仪表盘

            //打开链接
            url: "",

            // 绑定微信
            bindType: 0, // 0公众号 1小程序
            // 邀请成员
            inviteType: 0, // 0成员 1外部联系人
          },
          newPage: 1,  //是否在新页面打开，否则弹窗展示
          color: this.colorOpts[1], //颜色
          icon: "" //图标
        },
        {
          name: "点击编辑按钮",  //按钮名称
          optionType: SHORTCUT_BUTTON_TYPE__APPLY_FORM,  //applyForm:发起表单, openView:打开视图, openUrl:打开链接,
          id: uuid('BTN'),

          //根据类型解析
          optionContent: {
            //发起表单
            appId: '',
            formId: "",

            //打开视图
            //   "appId":"",
            //   "formId":"",
            viewId: "",
            jumpType: 1, // 1跳转视图，2跳转仪表盘

            //打开链接
            url: "",

            // 绑定微信
            bindType: 0, // 0公众号 1小程序
            // 邀请成员
            inviteType: 0, // 0成员 1外部联系人
          },
          newPage: 1,  //是否在新页面打开，否则弹窗展示
          color: this.colorOpts[2], //颜色
          icon: "" //图标
        },
        {
          name: "点击编辑按钮",  //按钮名称
          optionType: SHORTCUT_BUTTON_TYPE__APPLY_FORM,  //applyForm:发起表单, openView:打开视图, openUrl:打开链接,
          id: uuid('BTN'),

          //根据类型解析
          optionContent: {
            //发起表单
            appId: '',
            formId: "",

            //打开视图
            //   "appId":"",
            //   "formId":"",
            viewId: "",
            jumpType: 1, // 1跳转视图，2跳转仪表盘

            //打开链接
            url: "",

            // 绑定微信
            bindType: 0, // 0公众号 1小程序
            // 邀请成员
            inviteType: 0, // 0成员 1外部联系人
          },
          newPage: 1,  //是否在新页面打开，否则弹窗展示
          color: this.colorOpts[3], //颜色
          icon: "" //图标
        }
      ]
    }
  }

  get title() {
    return this.chartName || Shortcut._title
  }

  set title(content) {
    this.chartName = content
  }

}

Shortcut._title = ''
Shortcut.type = CHART_TYPE__SHORTCUT_CHART

Shortcut.prototype.chartCategory = CHART_CATEGORY__SHORTCUT
Shortcut.prototype.chartType = Shortcut.type

Shortcut.prototype.layoutModeOpts = [
  {
    label: '自适应',
    value: SHORTCUT_LAYOUT_MODE__ADAPT
  },
  {
    label: '等分',
    value: SHORTCUT_LAYOUT_MODE__FIXED
  }
]

export default Shortcut
